import React from 'react';
import {
  ArticleThumbnailImageProps,
  ImageProps,
} from './types/ArticleCard.types';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { ArticleThumbnailImage } from '../../Sections/SectionFilterableArticles/types/SectionFilterableArticles.types';

type ArticleCardThumbnailProps = {
  image: ArticleThumbnailImage | ImageProps;
};

const ArticleCardThumbnail: React.FC<ArticleCardThumbnailProps> = ({
  image,
}) => {
  if (!image) {
    return null;
  }

  if ('focalPoint' in image) {
    const {
      image: {
        title,
        description,
        gatsbyImageData,
        file: {
          details: {
            image: { height: imageHeight, width: imageWidth },
          },
        },
      },
      focalPoint: {
        focalPoint: { x: focalPointX, y: focalPointY },
      },
    } = image as ArticleThumbnailImageProps;

    const xCoordinate = (focalPointX / imageWidth) * 100;
    const yCoordinate = (focalPointY / imageHeight) * 100;

    return (
      <GatsbyImage
        image={getImage({ gatsbyImageData }) as IGatsbyImageData}
        imgStyle={{
          objectFit: 'cover',
          objectPosition: `${xCoordinate}% ${yCoordinate}%`,
        }}
        alt={description || title}
      />
    );
  }

  return (
    <GatsbyImage
      image={getImage(image) as IGatsbyImageData}
      alt={image.description || image.title}
    />
  );
};

export default ArticleCardThumbnail;
